import * as Slider from "@radix-ui/react-slider";

const WeightRangeFilter = ({
  productGram,
  setProductGram,
  filterProducts,
  closeDropdown,
}) => {
  const handleGramInputChange = (index, value) => {
    const newValue = [...productGram];
    newValue[index] = value === "" ? 0 : parseFloat(value);
    setProductGram(newValue);
  };

  const handleFilter = () => {
    filterProducts();
    if (closeDropdown) closeDropdown();
  };

  return (
    <div className="filter-section">
      <div className="slider-container">
        <div className="slider-values">
          <input
            type="number"
            value={productGram[0]}
            onChange={(e) => handleGramInputChange(0, e.target.value)}
            step="0.5"
            min="0"
            max="250"
          />
          <input
            type="number"
            value={productGram[1]}
            onChange={(e) => handleGramInputChange(1, e.target.value)}
            step="0.5"
            min="0"
            max="250"
          />
        </div>

        <Slider.Root
          className="SliderRoot"
          value={productGram}
          onValueChange={setProductGram}
          min={0}
          max={250}
          step={0.5}
          minStepsBetweenThumbs={1}
          aria-label="Price Range"
        >
          <Slider.Track className="SliderTrack">
            <Slider.Range className="SliderRange" />
          </Slider.Track>
          <Slider.Thumb className="SliderThumb" />
          <Slider.Thumb className="SliderThumb" />
        </Slider.Root>

        <div className="button_con">
          <button className="button primary_btn" onClick={handleFilter}>
            Filter
          </button>
        </div>
      </div>
    </div>
  );
};

const CaratRangeFilter = ({
  productCarat,
  setProductCarat,
  filterProducts,
  closeDropdown,
}) => {
  const handleCaratInputChange = (index, value) => {
    const newValue = [...productCarat];
    newValue[index] = value === "" ? 0 : parseFloat(value);
    setProductCarat(newValue);
  };

  const handleFilter = () => {
    filterProducts();
    if (closeDropdown) closeDropdown();
  };

  return (
    <div className="filter-section">
      <div className="slider-container">
        <div className="slider-values">
          <input
            type="number"
            value={productCarat[0]}
            onChange={(e) => handleCaratInputChange(0, e.target.value)}
            step="0.01"
            min="0"
            max="100"
          />
          <input
            type="number"
            value={productCarat[1]}
            onChange={(e) => handleCaratInputChange(1, e.target.value)}
            step="0.01"
            min="0"
            max="100"
          />
        </div>

        <Slider.Root
          className="SliderRoot"
          value={productCarat}
          onValueChange={setProductCarat}
          min={0}
          max={100}
          step={0.01}
          minStepsBetweenThumbs={1}
          aria-label="Weight Range"
        >
          <Slider.Track className="SliderTrack">
            <Slider.Range className="SliderRange" />
          </Slider.Track>
          <Slider.Thumb className="SliderThumb" />
          <Slider.Thumb className="SliderThumb" />
        </Slider.Root>
        <div className="button_con">
          <button className="button primary_btn" onClick={handleFilter}>
            Filter
          </button>
        </div>
      </div>
    </div>
  );
};

export { WeightRangeFilter, CaratRangeFilter };
